// Название пачки для показа: label пачки; @handle представителя нигде не выводится.
export function packDisplayName (pack) {
  return (typeof pack?.label === 'string' && pack.label.trim()) || 'Пачка';
}
